<template>
    <div class="mdt-offers-upperwrap">
        <market-section title="Tipos de Dispositivos Móviles" :articles="articles" section-type="devices"></market-section>
    </div>
</template>

<script>

import marketSection from '../utilities/market-section.vue';

export default {
    name: 'mobile-device-types',
    data: () => {
        return {
            articles: [
                {
                    name: 'Samsung Galaxy S9 Plus',
                    images: ['https://mlstaticquic-a.akamaihd.net/tapa-trasera-samsung-galaxy-s9-plus-purpura-coloc-zonalaptop-D_NQ_NP_951732-MLU27872891719_072018-F.jpg', 'http://cdi.app.io/images/offes-news-img/cell-samsung-1.png', 'http://cdi.app.io/images/offes-news-img/cell-samsung-2.png'],
                    category: 'Samsung',
                    price: 22500,
                    stars: 4
                },
                {
                    name: 'Samsung Galaxy J5',
                    images: ['https://www.moviles.com/fotos/samsung-galaxy-j5-prime-40764-g.jpg'],
                    category: 'Samsung',
                    price: 7000,
                    stars: 2
                },
                {
                    name: 'ZTE',
                    images: ['https://img3.bgxcdn.com/thumb/large/oaupload/banggood/images/A5/D9/64da9dd1-a706-4fa0-83a8-1eda25487a82.jpg'],
                    category: 'ZTE',
                    price: 7000,
                    stars: 5
                },
                {
                    name: 'Motorola',
                    images: ['https://img3.bgxcdn.com/thumb/large/oaupload/banggood/images/A5/D9/64da9dd1-a706-4fa0-83a8-1eda25487a82.jpg'],
                    category: 'Motorola',
                    price: 10000,
                    stars: 5
                },
                {
                    name: 'Huawei P20 Pro',
                    images: ['https://img3.bgxcdn.com/thumb/large/oaupload/banggood/images/A5/D9/64da9dd1-a706-4fa0-83a8-1eda25487a82.jpg'],
                    category: 'Huawei',
                    price: 22500,
                    stars: 5
                },
                {
                    name: 'Apple iPhone 6S',
                    images: ['https://images-na.ssl-images-amazon.com/images/I/61JCli7z77L._SY500_.jpg'],
                    category: 'Apple',
                    price: 22500,
                    stars: 3
                },
                {
                    name: 'Samsung Galaxy S9 Plus',
                    images: ['https://mlstaticquic-a.akamaihd.net/tapa-trasera-samsung-galaxy-s9-plus-purpura-coloc-zonalaptop-D_NQ_NP_951732-MLU27872891719_072018-F.jpg'],
                    category: 'Samsung',
                    price: 30000,
                    stars: 4
                },
                {
                    name: 'Samsung Galaxy J5',
                    images: ['https://www.moviles.com/fotos/samsung-galaxy-j5-prime-40764-g.jpg'],
                    category: 'Samsung',
                    price: 22500,
                    stars: 2
                },
                {
                    name: 'Huawei P20 Pro',
                    images: ['https://img3.bgxcdn.com/thumb/large/oaupload/banggood/images/A5/D9/64da9dd1-a706-4fa0-83a8-1eda25487a82.jpg'],
                    category: 'Huawei',
                    price: 22500,
                    stars: 5
                },
                {
                    name: 'Apple iPhone 6S',
                    images: ['https://images-na.ssl-images-amazon.com/images/I/61JCli7z77L._SY500_.jpg'],
                    category: 'Apple',
                    price: 22500,
                    stars: 3
                },
                {
                    name: 'Samsung Galaxy S9 Plus',
                    images: ['https://mlstaticquic-a.akamaihd.net/tapa-trasera-samsung-galaxy-s9-plus-purpura-coloc-zonalaptop-D_NQ_NP_951732-MLU27872891719_072018-F.jpg'],
                    category: 'Samsung',
                    price: 22500,
                    stars: 4
                },
                {
                    name: 'Samsung Galaxy J5',
                    images: ['https://www.moviles.com/fotos/samsung-galaxy-j5-prime-40764-g.jpg'],
                    category: 'Samsung',
                    price: 22500,
                    stars: 2
                },
                {
                    name: 'Huawei P20 Pro',
                    images: ['https://img3.bgxcdn.com/thumb/large/oaupload/banggood/images/A5/D9/64da9dd1-a706-4fa0-83a8-1eda25487a82.jpg'],
                    category: 'Huawei',
                    price: 22500,
                    stars: 5
                },
                {
                    name: 'Apple iPhone 6S',
                    images: ['https://images-na.ssl-images-amazon.com/images/I/61JCli7z77L._SY500_.jpg'],
                    category: 'Apple',
                    price: 22500,
                    stars: 3
                }
            ]
        }
    },
    components: { marketSection }
}
</script>

<style scoped>
    .mdt-offers-upperwrap {
        max-width: 1000px;
        width: 100%;
        margin: 0 auto;
    }
</style>


// WEBPACK FOOTER //
// device-mobile-types-offers.vue?1b837ba1